export const SEARCH_DELAY = 500;
export const DEFAULT_MAX_ENTRIES: number = 30;
export const convertRightName = (right: string): string => {
    switch (right) {
        case 'MANAGE_CATEGORY':
            return 'Kategorien verwalten';
        case 'MANAGE_CLEANER':
            return 'Reinigungskräfte verwalten';
        case 'MANAGE_OBJECTS':
            return 'Objekte verwalten';
        case 'MANAGE_MANAGER':
            return 'Objektleiter verwalten';
        case 'MANAGE_TRAINING':
            return 'Schulungen verwalten';
        case 'MANAGE_PRODUCTS':
            return 'Produkte verwalten';
        default:
            return right;
    }
}

export const statusOptions = [
    { label: 'Neu', value: 'NEW' },
    { label: 'Archiviert', value: 'ARCHIVED' },
];

export const MAX_TRAINING_ANSWERS = 6;